var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6762_13553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43242 12.0836L3.73625 14.6825L1.19176 14.7363C0.431328 13.3259 0 11.7122 0 9.99734C0 8.3391 0.403281 6.77535 1.11812 5.39844H1.11867L3.38398 5.81375L4.37633 8.06547C4.16863 8.67098 4.05543 9.32098 4.05543 9.99734C4.05551 10.7314 4.18848 11.4347 4.43242 12.0836Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8261 8.13281C19.941 8.73773 20.0009 9.36246 20.0009 10.0009C20.0009 10.7169 19.9256 11.4152 19.7822 12.0889C19.2954 14.3812 18.0234 16.3828 16.2613 17.7993L16.2608 17.7987L13.4075 17.6532L13.0037 15.1323C14.1729 14.4466 15.0866 13.3735 15.568 12.0889H10.2207V8.13281H15.646H19.8261Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2595 17.7975L16.2601 17.798C14.5464 19.1755 12.3694 19.9996 9.99965 19.9996C6.19141 19.9996 2.88043 17.8711 1.19141 14.7387L4.43207 12.0859C5.27656 14.3398 7.45074 15.9442 9.99965 15.9442C11.0952 15.9442 12.1216 15.648 13.0024 15.131L16.2595 17.7975Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.382 2.30219L13.1425 4.95437C12.2309 4.38461 11.1534 4.05547 9.99906 4.05547C7.39246 4.05547 5.17762 5.73348 4.37543 8.06812L1.11773 5.40109H1.11719C2.78148 2.1923 6.13422 0 9.99906 0C12.4254 0 14.6502 0.864297 16.382 2.30219Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6762_13553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9bf0a6a711bcfb3ef81af9de7368c978.svg";
export { ForwardRef as ReactComponent };